import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, liveMatches } from '@/mocks/data';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const currentCategory = category || categories[0];

  const categoryMatches = liveMatches.filter((m) => m.category === (slug || 'football'));
  const allCategories = categories;

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb />
      <main>
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50">
                <i className={`${currentCategory.icon} text-2xl text-primary-500`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                {currentCategory.name}赛事
              </h1>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                {currentCategory.description}
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {allCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2 text-sm rounded-full whitespace-nowrap transition-colors ${
                    cat.slug === (slug || 'football')
                      ? 'bg-primary-500 text-white font-medium'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
              <div className="grid grid-cols-12 gap-0 px-4 py-3 bg-background-100 text-xs font-semibold text-foreground-500">
                <div className="col-span-4">赛事</div>
                <div className="col-span-2 text-center">胜</div>
                <div className="col-span-2 text-center">平</div>
                <div className="col-span-2 text-center">负</div>
                <div className="col-span-2 text-right">状态</div>
              </div>

              {categoryMatches.length > 0 ? (
                categoryMatches.map((match, index) => (
                  <div
                    key={match.id}
                    className={`grid grid-cols-12 gap-0 px-4 py-3.5 items-center text-sm ${
                      index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                    } hover:bg-primary-50/50 transition-colors cursor-pointer`}
                  >
                    <div className="col-span-4">
                      <p className="text-xs text-foreground-400 mb-1">{match.league}</p>
                      <div className="flex items-center gap-2">
                        <span className="font-medium text-foreground-900">{match.homeTeam}</span>
                        {match.score && (
                          <span className="text-xs font-bold text-primary-500">{match.score}</span>
                        )}
                        <span className="font-medium text-foreground-900">{match.awayTeam}</span>
                      </div>
                    </div>
                    <div className="col-span-2 text-center">
                      <span className="inline-block px-3 py-1 bg-background-50 border border-background-200/60 rounded text-xs font-semibold text-foreground-700 hover:bg-primary-50 hover:border-primary-300 cursor-pointer">
                        {match.homeOdds}
                      </span>
                    </div>
                    <div className="col-span-2 text-center">
                      <span className="inline-block px-3 py-1 bg-background-50 border border-background-200/60 rounded text-xs font-semibold text-foreground-700 hover:bg-primary-50 hover:border-primary-300 cursor-pointer">
                        {match.drawOdds}
                      </span>
                    </div>
                    <div className="col-span-2 text-center">
                      <span className="inline-block px-3 py-1 bg-background-50 border border-background-200/60 rounded text-xs font-semibold text-foreground-700 hover:bg-primary-50 hover:border-primary-300 cursor-pointer">
                        {match.awayOdds}
                      </span>
                    </div>
                    <div className="col-span-2 text-right">
                      {match.status === 'live' ? (
                        <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium">
                          <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                          直播中 {match.time}
                        </span>
                      ) : match.status === 'upcoming' ? (
                        <span className="text-xs text-foreground-400">{match.time}</span>
                      ) : (
                        <span className="text-xs text-foreground-400">已结束</span>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="px-4 py-12 text-center text-foreground-500 text-sm">
                  暂无{currentCategory.name}赛事数据，敬请期待后续更新。
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}